import {
  Box,
  CircularProgress,
  Typography,
} from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { useEffect } from 'react'
import styles from './Loading.scss'
import LoadingStep from './LoadingStep'

interface LoadingProps {
  isFullScreen?: boolean
  loading: boolean
  message?: string
  onLoadingComplete?: () => void
}

const Loading = ({
  isFullScreen,
  loading,
  message,
  onLoadingComplete,
}: LoadingProps): JSX.Element => {
  const { breakpoints } = useTheme()
  const isSmallViewport = useMediaQuery(breakpoints.down('sm'))

  useEffect(() => {
    if (loading && onLoadingComplete) {
      const timer = setTimeout(() => {
        onLoadingComplete()
        // adjust based on last loading step
        // 4s transition with 1.5s delay
      }, 5500)
      return (): void => clearTimeout(timer)
    }
    return undefined
  }, [loading, onLoadingComplete])

  return (
    <Box
      className={styles.loadingContainer}
      width={(isFullScreen ?? isSmallViewport) ? 'unset' : '503px'}
      padding={(isFullScreen ?? isSmallViewport) ? 'unset' : '50px 0px 80px 0px'}
    >
      <Box className={styles.loadingProgressContainer}>
        <CircularProgress variant="indeterminate" size={180} thickness={3} sx={{ color: '#e2FAe3' }} />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
        >
          <LockIcon color="primary" fontSize="large" />
        </Box>
      </Box>
      <Box className={styles.loadingStepContainer}>
        {message ? (
          <Typography variant="h4Bold" color="primary.main">{message}</Typography>
        ) : (
          <>
            <LoadingStep
              loading={loading}
              message="Payment processed"
              transitionDelay="1s"
            />
            <LoadingStep
              loading={loading}
              message="Eligibility checked"
              transitionDelay="2.5s"
            />
            <LoadingStep
              loading={loading}
              message="Receipts filed"
              transitionDelay="4s"
            />
          </>
        )}
      </Box>
    </Box>
  )
}

export default Loading
